let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('9YSNU') + "css.worker.b48b03e3.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);